import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { getConventionPayState } from '../../lib/conventionPayState';

// Basket lines that count for the "Go to cart" button — same filter as the
// header cart icon (shipping lines are never user-added products).
export function countCartItems(cart) {
    return (cart || [])
        .filter(e => e.object?.type !== 'shipping')
        .reduce((acc, e) => acc + (Number(e.qty) || 0), 0);
}

@observer
class ConventionPayBottomBar extends Component {
    render() {
        const {
            stores,
            convention,
            signedUp,
            isInTheFuture,
            isRegistrationOpen,
            onPay,
            onGoToCart,
        } = this.props;
        const { userStore } = stores;
        const userId = userStore?.user?.id;
        const cartCount = countCartItems(userStore?.user?.cart);

        const state = getConventionPayState({
            convention,
            userId,
            signedUp,
            isInTheFuture,
            isRegistrationOpen,
            cartCount,
        });

        if (!state.visible) {
            return null;
        }

        let label;
        let icon = 'fa-duotone fa-bag-shopping';
        let onClick = onPay;
        if (state.action === 'paySignup') {
            label = <Text id='convention.pay-signup'>Pay signup</Text>;
        } else if (state.action === 'payNextStart') {
            label = (
                <Text
                    id='convention.pay-n-more-starts'
                    fields={{ remaining: state.remaining }}
                >
                    Pay for {state.remaining} more starts
                </Text>
            );
        } else if (state.action === 'goToCart') {
            icon = 'fa-duotone fa-cart-shopping';
            onClick = onGoToCart;
            label = (<>
                <Text id='convention.go-to-cart'>Go to cart</Text>
                <span class='badge rounded-pill text-bg-danger ms-2'>{state.cartCount}</span>
            </>);
        } else if (state.action === 'payNewSignup') {
            label = <Text id='convention.pay-new-signup'>Pay for new signup</Text>;
        }

        return (
            <div
                class='w-100 d-flex justify-content-center px-4 py-3 bg-body-secondary fixed-bottom'
                style='bottom: 0; left: 0; z-index: 1040;'
            >
                <button
                    type='button'
                    class={`btn btn-lg ${state.variant} rounded-pill w-100`}
                    style='max-width: 720px;'
                    onClick={onClick}
                >
                    <i class={`${icon} me-2`} />
                    {label}
                </button>
            </div>
        );
    }
}

export default ConventionPayBottomBar;
